module.exports = __webpack_public_path__ + "img/machineLearningValuationResults.879cca5f.jpg";